// @flow
import Passages from './Passages';

export default Passages;
